import type { IHeaderNav } from "./header";

export const HeaderNav: IHeaderNav[] = [
	{
		title: "Curiosity",
		path: "/curiosity",
	},
	{
		title: "Methods",
		path: "/methodologies",
	},
	{
		title: "Maps",
		path: "/map",
	},
	{
		title: "Galileo",
		path: "/galileo",
	},
	{
		title: "Abacus",
		path: "/abacus",
	},
	{
		title: "How To",
		path: "/how-to",
	},
];

export const AdminNav: IHeaderNav[] = [
	{
		title: "Admin",
		path: "/admin",
	},
];
